export const DEFAULT_WHITELABEL_CONFIGURATION_ID = 'ABACUS';
export const EMBURSE_SPEND_WHITELABEL_ID = 'EMBURSE_SPEND';
export const REACH_WHITELABEL_ID = 'EMBURSE_REACH';
export const SVB_WHITELABEL_ID = 'SVB';
export const EDITABLE_WHITELABEL_IDS = [DEFAULT_WHITELABEL_CONFIGURATION_ID, EMBURSE_SPEND_WHITELABEL_ID];
export const ALL_WHITELABEL_IDS = [
    DEFAULT_WHITELABEL_CONFIGURATION_ID,
    EMBURSE_SPEND_WHITELABEL_ID,
    REACH_WHITELABEL_ID,
    SVB_WHITELABEL_ID
];
